import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import wishlistQuery from '~/graphql/wishlist/wishlist.gql';
import addWishlistItemMutation from '~/graphql/wishlist/addWishlistItem.gql';
import deleteWishlistItemMutation from '~/graphql/wishlist/deleteWishlistItem.gql';
import isValidToken from '~/helpers/connection-helper';

function fetchDetailedWishlist(_x, _x2, _x3) {
  return _fetchDetailedWishlist.apply(this, arguments);
}

function _fetchDetailedWishlist() {
  _fetchDetailedWishlist = _asyncToGenerator(function* (_ref, offset, limit) {
    let {
      app,
      getters
    } = _ref;

    if (isValidToken()) {
      const locale = getters['i18n/locale'].iso;
      const {
        data
      } = yield app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: wishlistQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          locale,
          detailed: true,
          offset,
          limit
        }
      });
      return data && data.wishlist;
    }

    return null;
  });
  return _fetchDetailedWishlist.apply(this, arguments);
}

function fetchWishlist(_x4) {
  return _fetchWishlist.apply(this, arguments);
}

function _fetchWishlist() {
  _fetchWishlist = _asyncToGenerator(function* (context) {
    let detailed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (isValidToken()) {
      const locale = context.state.i18n.currentLocale;
      const response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: wishlistQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          locale: locale.iso,
          detailed
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchWishlist.apply(this, arguments);
}

function addWishlistItem(_x5, _x6) {
  return _addWishlistItem.apply(this, arguments);
}

function _addWishlistItem() {
  _addWishlistItem = _asyncToGenerator(function* (context, reference) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: addWishlistItemMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          reference
        }
      });
      return response.data;
    }

    return null;
  });
  return _addWishlistItem.apply(this, arguments);
}

function deleteWishlistItem(_x7, _x8) {
  return _deleteWishlistItem.apply(this, arguments);
}

function _deleteWishlistItem() {
  _deleteWishlistItem = _asyncToGenerator(function* (context, reference) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: deleteWishlistItemMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          reference
        }
      });
      return response.data;
    }

    return null;
  });
  return _deleteWishlistItem.apply(this, arguments);
}

export { fetchDetailedWishlist, fetchWishlist, addWishlistItem, deleteWishlistItem };